<div class="section-title">
{{ title }}
</div>
